import React, { lazy, useRef, useState } from "react";

/** Common Components */
import CardSection from "../../components/ui/card/CardSection";
import CenterModal from "../../components/ui/centerModal/CenterModal";
import "./XSDTemplate.scss";

/** Lazily Loaded Components */
const XSDTemplateList = lazy(() =>
  import("./components/xsdTemplatesList/XSDTemplateList")
);
const AddEditXSDTemplate = lazy(() =>
  import("./components/addEditXSDTemplate/AddEditXSDTemplate")
);

const XSDTemplate = () => {
  const molGridRef = useRef();
  const [isEdit, setIsEdit] = useState(false);
  const [editXSDTemplateData, seteditXSDTemplateData] = useState(null);
  const [isXSDTemplateModelOpen, setIsXSDTemplateModelOpen] = useState(false);

  const handleAddXSDTemplateClick = () => {
    setIsXSDTemplateModelOpen(true);
    seteditXSDTemplateData(null);
    setIsEdit(false);
  };

  const handleCloseModel = () => {
    setIsXSDTemplateModelOpen(false);
    seteditXSDTemplateData(null);
    setIsEdit(false);
  };

  const handleEditClick = (data) => {
    setIsEdit(true);
    seteditXSDTemplateData(data);
    setIsXSDTemplateModelOpen(true);
  };

  const handleSuccess = () => {
    handleCloseModel();
    if (molGridRef.current) {
      molGridRef.current?.refreshGrid();
    }
  };

  return (
    <>
      <div className="xsd-template-sec">
        <CardSection
          cardTitle={"XML Report Templates"}
          rightButton={true}
          buttonClassName={"blue-btn"}
          titleButtonClick={handleAddXSDTemplateClick}
          buttonText={"ADD"}
          searchInput={false}
          isButtonVisible={true}
          isButtonLoading={""}
          isIcon={true}
          iconClass="uil:plus"
        >
          <div className="only-list-body-scroll">
            <XSDTemplateList ref={molGridRef} onEdit={handleEditClick} />
          </div>
        </CardSection>
      </div>
      <CenterModal
        modalTitle={
          isEdit ? `Update XML Report Template` : `Add XML Report Template`
        }
        modalSize={"w-90"}
        isOpen={isXSDTemplateModelOpen}
        onClose={handleCloseModel}
        transition={"grow"}
      >
        <div className="xsd-report-template-model-sec">
          <AddEditXSDTemplate
            isEdit={isEdit}
            isOpen={isXSDTemplateModelOpen}
            initData={editXSDTemplateData}
            onClose={handleCloseModel}
            onSuccess={handleSuccess}
          />
        </div>
      </CenterModal>
    </>
  );
};

export default XSDTemplate;
